//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as storeApi from '@/api/store';
import * as categoryApi from '@/api/categoryApi.js';
import ExportNum from './exportNum.vue';
export default {
  components: {
    ExportNum: ExportNum
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      pageLoading: false,
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      brandOption: [],
      // 品牌
      merCateList: [],
      // 分类
      props: {
        children: 'categoryList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        leaf: 3
      } // 分类
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    this.initSearch();
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      storeApi.thirdSkuLists(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    initSearch: function initSearch() {
      this.getCategorySelect();
    },
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      this.merCateList = [];
      categoryApi.jdCateLists().then(function (res) {
        _this2.merCateList = res;
      });
    },
    exportGoods: function exportGoods() {
      var _this$listData;
      if (((_this$listData = this.listData) === null || _this$listData === void 0 ? void 0 : _this$listData.total) > 100000) {
        var _this$$refs$ExportNum;
        (_this$$refs$ExportNum = this.$refs['ExportNumRef']) === null || _this$$refs$ExportNum === void 0 ? void 0 : _this$$refs$ExportNum.openInit(this.listPram, this.listData.total);
      } else {
        storeApi.exportJdGoods(this.listPram).then(function (res) {
          window.open(res.fileName);
        });
      }
    },
    inputSort: function inputSort(row) {
      var _this3 = this;
      storeApi.changeJdSort({
        sort: row.sort,
        goodsId: row.id
      }).then(function (res) {
        _this3.handerSearch();
        _this3.$message.success('排序成功');
      }).catch(function (err) {
        _this3.handerSearch();
      });
    },
    inputPrice: function inputPrice(row) {
      var _this4 = this;
      storeApi.changeJdPrice({
        price: row.price,
        goodsId: row.id
      }).then(function (res) {
        _this4.handerSearch();
        _this4.$message.success('排序成功');
      }).catch(function (err) {
        _this4.handerSearch();
      });
    },
    syncProduct: function syncProduct() {
      var _this5 = this;
      this.$confirm('是否确定同步商品', '提示').then(function (result) {
        _this5.pageLoading = true;
        storeApi.syncThirdSku(_this5.listPram).then(function (data) {
          _this5.pageLoading = false;
          _this5.$message.success(data || '操作成功！');
          _this5.handlerGetListData(_this5.listPram);
        }).catch(function (err) {
          _this5.pageLoading = false;
        });
      });
    }
  }
};